
import { Component } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { Vue } from 'vue-property-decorator'

@Component({
  name: 'ImportUsersForm',
})

export default class ImportUserForm extends Vue {
  @Action('CreateUsersFromCSV', { namespace: 'Licenses' }) CreateUsersFromCSV!: any

  importUserVisible: boolean = true;
  selectedFile: any = null;
  tenantName: string = "";
  loading: boolean = false;
  error: boolean = false;
  usersImportedVisible: boolean = false;
  importedUsers: any = null;
  badlyFormattedEmails: any = null;
  usersAlreadyExist: any = null;

  rules: any = {
    required: (value: string) => !!value || this.$t('app.user.create.dialog.required'),
    email: (value: string) => /.+@.+\..+/.test(value) || this.$t('app.user.create.dialog.email'),
  }

  get isValid() {
    return this.tenantName && this.selectedFile;
  }

  closeUsersImportedDialog() {
    this.usersImportedVisible = false;
    this.$emit('close');
  }

  resetErrors() {
    (this.$refs.ImportUserForm as Vue & { resetValidation: () => boolean }).resetValidation();
    this.error = false;
  }

  async importUsers() {
    if (this.isValid) {
      this.loading = true;
      this.error = false;
      try {
        [this.importedUsers, this.badlyFormattedEmails, this.usersAlreadyExist] = await this.CreateUsersFromCSV({ file: this.selectedFile, tenantName: this.tenantName });
        this.$emit('imported');
      } catch (e) {
        this.error = true;
      } finally {
        this.loading = false;
        this.tenantName = "";
        this.selectedFile = null;
        this.importUserVisible = false;
        this.usersImportedVisible = true;
      }
    }
  }
}
